<template>
  <form id="detailInfoModal">
    <b-modal
      v-model="show"
      :title="workerId"
      modal-class="spso-modal"
      hide-header-close
      hide-footer
      centered
      size="lg"
      @hide="hideModal"
    >
      <div class="v-application spso-modal__body pt-4 break-word">
        <div
          v-if="isCreation"
          class="input-block input-block_white"
        >
          <v-textarea
            v-model="message"
            autocomplete="off"
            hide-details
            solo
          />
        </div>
        <vue-json-pretty
          v-if="(isCreation && parsedMessage) || decodedObject"
          :deep="2"
          show-length
          :select-on-click-node="false"
          :data="isCreation ? parsedMessage : decodedObject"
        />
        <div
          v-else
          class="d-flex py-4"
        >
          <span class="mx-auto">Нет данных</span>
        </div>

        <div class="v-application d-flex mt-4 sticky-bottom">
          <div
            v-if="!isCreation && detailInfo"
            class="icons-body-position"
          >
            <v-row>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    :color="body.decode ? 'primary' : 'secondary'"
                    size="20"
                    v-bind="attrs"
                    @click="body.decode = !body.decode"
                    v-on="on"
                  >
                    mdi-cpu-64-bit
                  </v-icon>
                </template>
                <span>Decode body</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    :color="body.json ? 'primary' : 'secondary'"
                    size="20"
                    v-bind="attrs"
                    @click="body.json = !body.json"
                    v-on="on"
                  >
                    mdi-code-json
                  </v-icon>
                </template>
                <span>JSON.parse body</span>
              </v-tooltip>
            </v-row>
          </div>
          <v-btn
            v-if="isCreation"
            color="primary"
            class="mr-4 flex-grow-1"
            outlined
            large
            :loading="loading"
            @click="createMessage"
          >
            {{ $t('common.create') }}
          </v-btn>

          <v-btn
            color="primary"
            class="mr-4 flex-grow-1"
            outlined
            large
            @click="hideModal"
          >
            {{ $t('common.close') }}
          </v-btn>
        </div>
      </div>
    </b-modal>
  </form>
</template>

<script>
import 'vue-json-pretty/lib/styles.css';

export default {
  name: 'DetailInfoModal',
  props: {
    value: Boolean,
    detailInfo: Object,
    isCreation: Boolean,
    isReschedule: Boolean,
    workerId: String,
  },
  data: () => ({
    show: false,
    message: '',
    loading: false,
    body: {
      decode: false,
      json: false,
    },
  }),
  computed: {
    parsedMessage() {
      return this.message ? JSON.parse(this.message) : '';
    },
    decodedObject() {
      if (!this.detailInfo) { return this.detailInfo; }

      const { body } = this.detailInfo;

      try {
        const decodedBody = this.body.decode ? this.b64_to_utf8(body) : body;
        return { ...this.detailInfo, body: this.body.json ? JSON.parse(decodedBody) : decodedBody };
      } catch (err) {
        return this.detailInfo;
      }
    },
  },
  watch: {
    value(val) {
      this.show = val;
      this.message = '';
      if (this.isReschedule) {
        this.message = JSON.stringify(this.detailInfo);
      }
      this.loading = false;
    },
  },
  methods: {

    b64_to_utf8(str) {
      str = str.replace(/\s/g, '');
      return decodeURIComponent(escape(window.atob(str)));
    },
    createMessage() {
      this.$emit('create', this.parsedMessage);
      this.loading = true;
    },
    hideModal() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.break-word {
  overflow-wrap: break-word;
}

.icons-body-position {
  margin: 25px;
}

</style>
